import FieldString from "../../../fields3/generic/string/string"
import FieldNumber_ManagementForm from "./render/management-form"
import FieldConfig from "../../proto/field-config"
import FormManager from "../../../gd-form/common/form-manager"
import FieldNumber_ManagementPreview from "./render/management-preview"
import {GROUP_NUMBER} from "../../../gd/const/fields/field2-groups"
import FieldNumber_AutomationTriggerForm from "./render/automation/automation-trigger"
import FieldNumber_AutomationConditionForm from "./render/automation/automation-condition"
import FieldNumber_AutomationActionForm from "./render/automation/automation-action"
import toFloat from "../../../gd/format/to-float"
import normalizeNumber from "../../import/normalize/normalize-number"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldNumber_FormElement from "./render/form-element"
import FieldNumber_Editable from "./render/editable/editable"
import FieldNumber_GoalListEditable from "./render/goal-list-editable"
import FieldNumber_GoalListView from "./render/goal-list-view"
import FieldNumber_InlineEditable from "./render/inline-editable"
import {FieldFilterType} from "../../proto/types"
import {
    ConditionType_IsNull,
    ConditionType_NotNull, ConditionType_NumberEquals,
    ConditionType_NumberGreaterThan, ConditionType_NumberLessThan
} from "../../../model2/conditions/condition-types"
import FieldNumber_ConditionForm from "./render/condition"

export default class FieldNumber extends FieldString {


    public minValue : number | null
    public maxValue : number | null
    public prefix   : string | null
    public postfix  : string | null

    // RENDER_CLASS                = FieldNumber_Render
    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Number";         // ?????
        this.typeGroup          = GROUP_NUMBER;
        this.typeDescription    = "Generic number field";
        this.filterType         = FieldFilterType.NUMBER;
        this.icon               = config.icon || 'i5-numbers'

        // special
        this.decimalPlaces      = _.get(config,'decimalPlaces',0)
        this.positiveOnly       = _.get(config,'positiveOnly',false)
        this.integersOnly       = _.get(config,'integersOnly',false)
        this.minValue           = _.get(config,'minValue',null)
        this.maxValue           = _.get(config,'maxValue',null)
        this.prefix             = _.get(config,'prefix',null)
        this.postfix            = _.get(config,'postfix',null)

        this.conditionTypes     = [
            ConditionType_NotNull,
            ConditionType_IsNull,
            ConditionType_NumberGreaterThan,
            ConditionType_NumberLessThan,
            ConditionType_NumberEquals
        ]

        _.assign(this.components, {
            // Vic removed in matrch 2023 - not needed I think
            // ValueIcon: <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        })

        this.renderComponents.inlineEditable            = FieldNumber_InlineEditable

        this.renderComponents.managementPreview         = FieldNumber_ManagementPreview
        this.renderComponents.managementForm            = FieldNumber_ManagementForm

        this.renderComponents.automationTriggerForm     = FieldNumber_AutomationTriggerForm
        this.renderComponents.automationConditionForm   = FieldNumber_AutomationConditionForm
        this.renderComponents.automationActionForm      = FieldNumber_AutomationActionForm

        this.renderComponents.formElement               = FieldNumber_FormElement
        this.renderComponents.editable                  = FieldNumber_Editable
        this.renderComponents.conditionForm             = FieldNumber_ConditionForm

        this.renderComponents.goalListEditable          = FieldNumber_GoalListEditable
        this.renderComponents.goalListView              = FieldNumber_GoalListView
    }

    normalizeValue(value: number|null): number|null {

        // we have type issues here !
        value = toFloat(value)

        if (_.isNil(value)) return null

        // min max can be 0 so be carefull with check - only null
        if (this.minValue!==null) {
            if (value<this.minValue) value = this.minValue
        }

        if (this.maxValue!==null) {
            if (value>this.maxValue) value = this.maxValue
        }

        return value
    }

    sortValue(value:any) {
        return value ? value : 0
    }

    searchValue(value:any) { return !_.isNil(value) && !isNaN(value) ? '' + value : ''; }

    /*** VALIDATION FUNCTIONS ***/

    isValueValid(value:any) {

        // value can be empty
        if (_.isNil(value)) {
            return true
        }

        let isValid = !isNaN(value) || value.length === 0

        // additional check min max
        if (isValid) {

            if (this.minValue!==null) {
                isValid = isValid && value>=this.minValue
            }

            if (this.maxValue!==null) {
                isValid = isValid && value<=this.maxValue
            }

        }

        return isValid
    }

    // formManager field validator
    validator(value:any, formManager:FormManager) {
        return this.isValueValid(value) || '{0} value is invalid'.f(this.label)
    }

    /*** DISPLAY VALUE FUNCTIONS [INPUT ONLY] ***/

    getDisplayValue(value:any) {

        // console.log("getDisplayValue()", value)

        if (isNaN(value)) return value;

        let res = value;

        if (this.isValueValid(value)) {
            switch (typeof value) {
                case 'number':
                    res = value.toFixed(this.decimalPlaces); break;
                default:
                    res = parseFloat(value).toFixed(this.decimalPlaces); break;
            }
        }

        let result: any = isNaN(res) || _.isNil(value) ? '' : res;

        // console.log("    result=", result)

        return (this.prefix ? this.prefix : '') + result + (this.postfix ? this.postfix : '')
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeNumber(value)
    }

    toJson() {
        let result = super.toJson()
        result.decimalPlaces    = this.decimalPlaces
        result.positiveOnly     = this.positiveOnly
        result.integersOnly     = this.integersOnly

        return result
    }
}
